import { create } from "zustand";

type DocsFilterState = {
  searchValue: string | null;
  setSearchValue: (searchValue: string | null) => void;
  topicId: string | null;
  setTopicId: (topicId: string | null) => void;
};

export const useDocsFilterStore = create<DocsFilterState>((set) => ({
  searchValue: null,
  setSearchValue: (searchValue) => set({ searchValue }),
  topicId: null,
  setTopicId: (topicId) => set({ topicId }),
}));
